import React from 'react'
import Logo from '../components/Logo'
import Footer from '../components/Footer'
import MenuMobile from '../components/MenuMobile'
import MenuDesk from '../components/MenuDesk'
import SEO from '../components/SEO'
import FaAngleUp from 'react-icons/lib/fa/angle-up'
import ScrollToTop from 'react-scroll-up'

import styles from './index.css'

const Layout = ({ children, data, location, history }) => {
  var windowWidth = 1000
  typeof window !== 'undefined' && (windowWidth = window.innerWidth)
  let isHome = false
  if (location.pathname === `${process.env.pathPrefix}`) {
    return children({ data, location, history })
  } else {
    return (
      <div className="grid">
        <div className="header">
          <Logo data={data} />
          {windowWidth < 700 && <MenuMobile />}
          {windowWidth > 700 && <MenuDesk />}
        </div>
        <div className="main">{children({ data, location, history })}</div>
        <Footer />
        <ScrollToTop showUnder={160} style={{ right: 20 }}>
          <FaAngleUp style={{ fontSize: '1.8rem' }} />
        </ScrollToTop>
      </div>
    )
  }
}

export default Layout

export const query = graphql`
  query global {
    site {
      siteMetadata {
        title
      }
    }
    editorial: allFile(filter: { id: { regex: "/editorial/" } }, sort: { fields: [id] }) {
      edges {
        node {
          childImageSharp {
            sizes(maxWidth: 1200, quality: 90) {
              ...GatsbyImageSharpSizes_withWebp
            }
          }
        }
      }
    }
    freiearbeiten: allFile(filter: { id: { regex: "/freiearbeiten/[a-z0-9].jpg/" } }, sort: { fields: [id] }) {
      edges {
        node {
          childImageSharp {
            sizes(maxWidth: 1200, quality: 90) {
              ...GatsbyImageSharpSizes_withWebp
            }
          }
        }
      }
    }
    brotundspiele: allFile(filter: { id: { regex: "/freiearbeiten/brotundspiele/.*.jpg/" } }, sort: { fields: [id] }) {
      edges {
        node {
          childImageSharp {
            sizes(maxWidth: 1200, quality: 90) {
              ...GatsbyImageSharpSizes_withWebp
            }
          }
        }
      }
    }
    offseason: allFile(filter: { id: { regex: "/freiearbeiten/offseason/.*.jpg/" } }, sort: { fields: [id] }) {
      edges {
        node {
          childImageSharp {
            sizes(maxWidth: 1200, quality: 90) {
              ...GatsbyImageSharpSizes_withWebp
            }
          }
        }
      }
    }
    humanstudies: allFile(filter: { id: { regex: "/freiearbeiten/humanstudies/.*.jpg/" } }, sort: { fields: [id] }) {
      edges {
        node {
          childImageSharp {
            sizes(maxWidth: 1200, quality: 90) {
              ...GatsbyImageSharpSizes_withWebp
            }
          }
        }
      }
    }
    hafengefluester: allFile(filter: { id: { regex: "/freiearbeiten/hafengefluester/.*.jpg/" } }, sort: { fields: [id] }) {
      edges {
        node {
          childImageSharp {
            sizes(maxWidth: 1200, quality: 90) {
              ...GatsbyImageSharpSizes_withWebp
            }
          }
        }
      }
    }
    portrait: allFile(filter: { id: { regex: "/portrait/" } }, sort: { fields: [id] }) {
      edges {
        node {
          childImageSharp {
            sizes(maxWidth: 1200, quality: 90) {
              ...GatsbyImageSharpSizes_withWebp
            }
          }
        }
      }
    }
    reportage: allFile(filter: { id: { regex: "/reportage/" } }, sort: { fields: [id] }) {
      edges {
        node {
          childImageSharp {
            sizes(maxWidth: 1200, quality: 90) {
              ...GatsbyImageSharpSizes_withWebp
            }
          }
        }
      }
    }
    travel: allFile(filter: { id: { regex: "/travel/" } }, sort: { fields: [id] }) {
      edges {
        node {
          childImageSharp {
            sizes(maxWidth: 1200, quality: 90) {
              ...GatsbyImageSharpSizes_withWebp
            }
          }
        }
      }
    }
    wedding: allFile(filter: { id: { regex: "/wedding/" } }, sort: { fields: [id] }) {
      edges {
        node {
          childImageSharp {
            sizes(maxWidth: 1200, quality: 90) {
              ...GatsbyImageSharpSizes_withWebp
            }
          }
        }
      }
    }
    logo: file(relativePath: { regex: "/logo.png/" }) {
      childImageSharp {
        sizes(maxWidth: 800, quality: 90) {
          ...GatsbyImageSharpSizes_withWebp_noBase64
        }
      }
    }
    logotext: file(relativePath: { regex: "/logo-text.png/" }) {
      childImageSharp {
        sizes(maxWidth: 800, quality: 90) {
          ...GatsbyImageSharpSizes_withWebp_noBase64
        }
      }
    }
    landing: file(relativePath: { regex: "/landing.jpg/" }) {
      childImageSharp {
        sizes(maxWidth: 800, quality: 90) {
          ...GatsbyImageSharpSizes_withWebp_noBase64
        }
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/layouts/index.js